module.exports = require('./helpers/bundle-url').getBundleURL('i2AHq') + "logo.7718c6df.svg";